import { storageManager } from 'atoms/utils';

const { getCookie, getStorage, removeStorage, setStorage } = storageManager;

export { getCookie, getStorage, removeStorage, setStorage };
